<template>
  <div>
    <div class="commodityHead flex-center">
      <div style="margin-bottom:10px;font-weight:bold;">供应商</div>
    </div>
    <div class="invoivingImg" @click="jumpTT('/invoicingFather/invoicingSet')">
      <img src="../../assets/icon/gysgl.png" alt />
      <div class="cardText">
        <div>供货商管理</div>
        <div class="cardText-two">供应商查看或管理</div>
      </div>
      <div class="cardIcon" @click.stop="jumpTT('/invoicingFather/editSupplier')">
        <img src="../../assets/icon/jxcjh.png" alt />
      </div>
    </div>
    <div class="commodityHead2 flex-center">
      <div style="margin-bottom:10px;font-weight:bold;">进货</div>
    </div>
    <div class="row">
      <div class="invoivingImg" @click="jumpTT('/invoicingFather/goodsPurchase')">
        <img src="../../assets/icon/jhd.png" alt />
        <div class="cardText">
          <div>进货单</div>
          <div class="cardText-two">最近新增销售：{{newPurchaseMoney}}元</div>
        </div>
        <div class="cardIcon" @click.stop="jumpTT('/invoicingFather/addGoodsPurchase')">
          <img src="../../assets/icon/jxcjh.png" alt />
        </div>
      </div>
      <div class="invoivingImg" @click="jumpTT('/invoicingFather/goodsPurchaseReturn')">
        <img src="../../assets/icon/jhthd.png" alt />
        <div class="cardText">
          <div>进货退货单</div>
          <div class="cardText-two">关联进货单退货或直接退货</div>
        </div>
        <div class="cardIcon" @click.stop="jumpTT('/invoicingFather/addGoodsPurchaseReturn')">
          <img src="../../assets/icon/jxcjh.png" alt />
        </div>
      </div>
    </div>
    <div class="commodityHead2 flex-center">
      <div style="margin-bottom:10px;font-weight:bold;">库存</div>
    </div>
    <div class="row">
      <div class="invoivingImg" @click="jumpTT('/invoicingFather/stockCheck')">
        <img src="../../assets/icon/kcpd.png" alt />
        <div class="cardText">
          <div>库存盘点</div>
          <div class="cardText-two">最近新增盘点商品数量{{checkStatus}}</div>
        </div>
        <div class="cardIcon">
          <img src="../../assets/icon/jxcjh.png" alt />
        </div>
      </div>
      <div class="invoivingImg"  @click="jumpTT('/invoicingFather/stockInquiry')">
        <img src="../../assets/icon/kccx.png" alt />
        <div class="cardText">
          <div>库存查询</div>
          <!-- <div class="cardText-two">关联销售单或直接退货</div> -->
        </div>
        <!-- <div class="cardIcon">
          <img src="../../assets/icon/jxcjh.png" alt />
        </div> -->
      </div>
      <div class="invoivingImg" @click="jumpTT('/invoicingFather/goodsChange')">
        <img src="../../assets/icon/dbd.png" alt />
        <div class="cardText">
          <div>调拨单</div>
          <div class="cardText-two">仓库间转移商品</div>
        </div>
        <div class="cardIcon">
          <img src="../../assets/icon/jxcjh.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getNewstInfo } from "../api"
export default {
  data() {
    return {
      userList: {},
      newPurchaseMoney: "",
      checkStatus: ""
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    this.userList = userList;
    this.getNewstInfo()
  },
  methods: {
    //跳转
    jumpTT(adress, message) {
      // this.$router.push(adress)
      this.$router.push({ path: adress, query: { docId: message } });
    },
    getNewstInfo() {
      getNewstInfo({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        pageNo: 1,
        row: 999999
      })
      .then(res => {
        if (res.code == 1) {
          if (res.data.newPurchaseMoney) {
            this.newPurchaseMoney = res.data.newPurchaseMoney.toFixed(2)
          }
          if (res.data.checkStatus == 0) {
            this.checkStatus = "无盈亏"
          } else {
            this.checkStatus = "有盈亏"
          }
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
            this.$message.error(res.msg);
        }
      })
    },
    a() {
      console.log(1)
    },
    b() {
      console.log(2)
    }
  }
};
</script>
<style scoped>
.commodityHead {
  box-sizing: border-box;
  width: calc(100vw - 200px);
  padding: 15px 20px 30px 30px;
  background: #f8f8f8;
  height: 36px;
  padding-top: 65px;
  z-index: 99;
  font-size: 12px;
  color: #333333;
}
.commodityHead2 {
  box-sizing: border-box;
  width: calc(100vw - 200px);
  padding: 15px 20px 30px 30px;
  background: #f8f8f8;
  height: 36px;

  z-index: 99;
  font-size: 12px;
  color: #333333;
}
img {
  height: 100%;
  width: 100%;
}
.invoivingImg {
  height: 78px;
  width: 258px;
  margin: 30px 0 30px 30px;
  position: relative;
  cursor: pointer;
}
.cardText {
  position: absolute;
  top: 17px;
  left: 80px;
  font-size: 16px;
  color: #fff;
}
.cardText-two {
  font-size: 12px;
  margin-top: 8px;
}
.cardIcon {
  height: 15px;
  width: 15px;
  position: absolute;
  left: 228px;
  top: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/invoicing.vue